import type * as ents from '@attain-apps/entities'

/**
 * {@link https://ngrx.io/docs State} of this feature.
 */
export interface State {
  readonly context?: State.Context
}
export namespace State {
  export const INITIAL: State = {}

  /**
   * Ephemeral, externally-supplied context for the assistant slideout
   * session, e.g. a set of DMS records provided by a mosaic action so the
   * agent can use them for knowledge-base retrieval for the duration that
   * the slideout stays open for the given agent.
   */
  export interface Context {
    readonly agentId: ents.core.agent.Agent.Id
    readonly records: readonly ents.core.agent.KnowledgeBase.Retrieval.Record[]
  }

  export function open(state: State, context: Context): State {
    return { ...state, context }
  }

  export function clear(state: State): State {
    return { ...state, context: undefined }
  }
}
